<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :toolbar-config="tableToolbar"
    :loading="loading"
    :height="height"
    size="mini"
    resizable
    border
    :seq-config="{
      startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
    }"
    :radio-config="{ highlight: true, trigger: 'row' }"
    :checkbox-config="{
      highlight: true,
      reserve: true,
    }"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:status="{ row }">
      <el-tag
        size="mini"
        :type="row.formulaStatus === 'Y' ? 'light' : 'warning'"
      >
        {{ row.formulaStatusName }}
      </el-tag>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: { type: Boolean, default: false },
    height: { type: Number, default: 300 },
    type: { type: String, default: 'radio' },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    choiceData() {
      if (this.type === 'checkbox') {
        return this.getCheckboxRecords()
      }
      if (this.type === 'radio') {
        return this.getRadioRecord()
      }
    },
    getRadioRecord() {
      const data = this.$refs.vxeGrid.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid
        .getCheckboxRecords()
        .concat(this.$refs.vxeGrid.getCheckboxReserveRecords())
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
  },
}
</script>
